module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/check-051a17661f5420b2f789c81cff6f9736.svg";